import React from "react";
import { Box, Button, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import theme from "theme";

const EmptyPlaceHolder = ({ title, onAdd, icon: Icon = PersonIcon }) => {
    return (
        <Box
            sx={{
                border: "1px dashed #ccc",
                borderRadius: 2,
                p: 3,
                textAlign: "center",
                bgcolor: "#fafafa"
            }}
        >
            <GridContainer direction="column" spacing={1}>
                <GridItem>
                    <Icon
                        sx={(theme) => ({
                            fontSize: 64,
                            color: "grey.400",
                            mb: 1,
                            fill: theme.palette.primary.main
                        })}
                    />
                </GridItem>
                <GridItem>
                    <Typography variant="body1" color="text.secondary">
                        No {title} added yet.
                    </Typography>
                </GridItem>
                <GridItem>
                    <Button variant="contained" onClick={onAdd} sx={{ mb: 2 }}>
                        Add {title} to get started.
                    </Button>
                </GridItem>
            </GridContainer>
        </Box>
    );
};

export default EmptyPlaceHolder;
